import { Input } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';

const DynamicFieldTimePicker = ({ value, ...props }) => {
  const toShow = useMemo(() => ((value && moment(value).isValid()) && moment(value).format('h:mm A')) || value, [value]);
  
  return <Input defaultValue={toShow} {...props} style={{ width: '25%' }}/>;
};

DynamicFieldTimePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldTimePicker);
